var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"photo-analysis-result-update-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","click-to-close":false,"width":800,"height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('photo-analysis-result-update')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }